import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { EndpointService } from '@app/core';
import { TipoAsociacion } from '@app/shared';

@Injectable()
export class ManageAssociationDataService {
  constructor(
    private http: HttpClient,
    private toastr: ToastrService,
    private api: EndpointService
  ) { }

  /**
   * Consulta los tipos de asociaciones
   *
   * @returns {Observable<TipoAsociacion[]>}
   * @memberof ManageAssociationDataService
   */
  getTypesAssociations(): Observable<TipoAsociacion[]> {
    return new Observable(obs => {
      this.http.get<TipoAsociacion[]>(this.api.get('typeAssociation')).subscribe(
        associations => {
          obs.next(associations);
        },
        err => {
          obs.error(err);
        }
      );
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/administration/process-automation/manage-association/shared/manage-association.data.service.ts